import React, { useCallback } from "react";
import { FilterChip } from "../FilterChip";
import { ProductFilterValue } from "./types";
import { PRODUCT_LIST_UPLOAD_PROPS } from "../ProductFilter/constants";
import { ProductFilter } from "./ProductFilter";

/**
 * Product-specific implementation of FilterChip
 */
export const ProductFilterChip: React.FC<{
  selectedProducts?: ProductFilterValue;
  onProductsSelect: (value: ProductFilterValue) => void;
  onDelete?: () => void;
  id?: string;
}> = ({
  selectedProducts = { ids: [], inclusionMethod: "ANY_PRESENT" },
  onProductsSelect,
  onDelete,
  id = "products",
}) => {
  const renderLabel = useCallback(() => {
    if (selectedProducts.ids.length === 0) {
      return "Select Products";
    }

    if (selectedProducts.ids.length === 1) {
      return "1 product";
    }

    return `${selectedProducts.ids.length} products`;
  }, [selectedProducts]);

  return (
    <FilterChip
      id={id}
      label="Products"
      getSelectedCount={() => selectedProducts.ids.length}
      renderLabel={renderLabel}
      onDelete={onDelete}
      popoverOptions={{
        disableActionButtons: true,
      }}
      paperStyles={{ width: "500px" }}
    >
      <ProductFilter
        selectedProductIds={selectedProducts.ids}
        onProductsSelect={onProductsSelect}
        uploadProps={PRODUCT_LIST_UPLOAD_PROPS}
      />
    </FilterChip>
  );
};
